module.exports = __webpack_public_path__ + "img/pJko.149288c0.svg";